import styled from 'styled-components';
import breakpoint from '../breakpoints';

export const Wrapper = styled.section`
  width: 90%;
  display: flex;
  margin: 0 auto;
  padding: 70px 0;
  border-bottom: 1px solid #ccc;
  ${breakpoint('mobile', 'down')}{
    margin: 0 auto;
    padding-bottom: 20px;
    padding-top: 20px;
  }
`

export const Heading = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0;
  ${breakpoint('tablet', 'down')} {
    margin: 0 20px;
    flex-direction: column;
    align-items: center;
  }
`
export const HeadingContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 calc(50% - 30px);
  padding-left: 30px;
  ${breakpoint('tablet', 'down')} {
    flex: 1;
    align-items: center;
    padding-left: 0;
    padding-bottom: 0;
    width: 100%
  }
  ${breakpoint('mobile', 'down')}{
    flex-direction: column;
    padding-bottom: 15px;
  }
`

export const HeadingImg = styled.div`
  flex: 0 0 calc(50% - 30px);
  padding-top: 10px;
  img {
    width: 100%;
  }
  ${breakpoint('tablet', 'down')} {
    flex: 1;
    align-items: center;
    width: 100%
  }
`

export const LicenseSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 20px auto;
`

export const Row = styled.div`
  display: flex;
  margin: 0;
  ${breakpoint('mobile', 'down')}{
    flex-direction: column;
  }
`

export const License = styled.div`
  padding: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  margin: 0;
  &:after {
    content: '';
    position: absolute;
    height: 90px;
    border-right: 1px solid #ccc;
    left:0;
    ${breakpoint('mobile', 'down')}{
      border: none;
    }
  }
  &:first-child {
    &:after {
      border: none;
    }
  }

`

export const Title = styled.h3`
  font-family: "ToyotaType Bold"; 
  letter-spacing: 0.025em; 
  font-size: ${({small}) => small ? '22px' : '26px'}; 
  line-height: 36px; 
  margin-bottom: 15px;
  padding: 0;
  
  ${breakpoint('tablet', 'down')} {
    margin-top: 15px;
  }
  
  ${breakpoint('mobile', 'down')} {
    margin-top: 0;
  }

`

export const Description = styled.p`
  font-family: "ToyotaType Book"; 
  font-size: 13px; 
  line-height: 20px; 
  letter-spacing: 0.05em; 
  margin-bottom: 0;
  ${breakpoint('tablet', 'down')} {
    margin: 0;
  }
  
  ${breakpoint('mobile', 'down')} {
    margin-bottom: 15px;
  }
`

export const Link = styled.a`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  color: #CC0000;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #990000;
  }
`